<template>
  <div class="sb-modal-footer">
    <slot />
  </div>
</template>
